import { makeStyles } from "@material-ui/core/styles";
import { Button, ListItem, ListItemAvatar } from "@mui/material";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import LoadingGrid from "components/Loading/LoadingFull";
import MeuPlanoAtual from "components/Uteis/MeuPlanoAtual";
import MySnackbarErro from "components/Uteis/MySnackbarErro";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import api from "services/api.js";
import { serverApi } from "services/constante.js";
import ModalConfirmacaoAceiteContratoVenda from 'components/Uteis/ModalConfirmacaoAceiteContratoVenda';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const STEP_CONTRATO = 'CONTRATO';
const STEP_SNE = 'SNE';
const STEP_NAO_GARANTIA = 'NAO_GARANTIA';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: 'trnsparent',
    },
    titulo: {
        fontSize: '14px',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500
    },
    inline: {
        display: 'inline',
        color: '#787878',
        fontFamily: 'Montserrat, sans-serif',
    },
    iconColor: {
        color: "#FFF"
    },
    boxPontosDK: {
        position: 'absolute',
        bottom: '15px',
        left: '2px',
        color: '#737495'
    },
    boxPontosMB: {
        position: 'absolute',
        bottom: '0px',
        left: '5px',
        top: '30px',
        color: '#737495'
    },
    itemList: {
        position: 'relative',
        backgroundColor: 'white',
        marginBottom: '15px',
        borderRadius: '10px',
        marginRight: '20px',
        marginLeft: '20px',
        paddingTop: '15px',
        cursor: 'pointer',
    },
    statusDisplay: {
        width: 10,
        height: 10,
        display: 'inline-block',
        borderRadius: '5px',
        marginRight: '5px'
    },
    boxStatus: {
        marginRight: '7px',
        fontFamily: 'Montserrat, sans-serif',
    },
    textStatusDisplay: {
        color: '#787878'
    },
    boxConteudo: {
        paddingLeft: '5px'
    },
    headerDivider: {
        borderLeft: '1px solid #e2e2e2',
        borderRight: '1px solid #e2e2e2',
        height: '77px',
        position: 'absolute',
        left: '65px',
        top: '35px'
    }
}));


export default function PedidoContrato(props) {
    const [loadingGrid, setLoadingGrid] = useState(true);
    const [contratoLink, setContratoLink] = useState(null);
    const [isErro, setIsErro] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLodingPdf, setIsLodingPdf] = useState(true);
    const [open, setOpen] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [currentStep, setCurrentStep] = useState(null);
    const [termoSneLink, setTermoSneLink] = useState(null);
    const [termoNaoGarantiaLink, setTermoNaoGarantiaLink] = useState(null);

    const classes = useStyles();

    const vendaId = props?.match?.params?.vendaId;
    // console.log('pr', props);

    const carregarContrato = async () => {
        const userResponse = await api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil');
        const user = userResponse.data;
        const userGuid = user.Guid;

        const formData = new FormData();
        formData.append("function", "get_contrato");
        formData.append("venda_id", vendaId);
        const res = await api.post(serverApi.urlPHP + '/venda.php', formData);

        if (res.data.contrato_assinado) {
            return true;
        }

        if (res.data.contrato_link) {
            setContratoLink(res.data.contrato_link);
            setCurrentStep(STEP_CONTRATO);
            setNumPages(null);
            setIsLodingPdf(true);
            setErrorMessage(null);
            return false;
        }

        throw new Error("Contrato link não encontrado na resposta");
    };

    const carregarTermoSNE = async () => {
        const formData = new FormData();
        formData.append("function", "get_termo_sne");
        formData.append("venda_id", vendaId);
        const res = await api.post(serverApi.urlPHP + '/venda.php', formData);

        if (res.data.termo_sne_assinado) {
            return true;
        }

        if (res.data.termo_sne_link) {
            setTermoSneLink(res.data.termo_sne_link);
            setCurrentStep(STEP_SNE);
            setNumPages(null);
            setIsLodingPdf(true);
            setErrorMessage(null);
            return false;
        }

        throw new Error("Termo SNE link não encontrado na resposta");
    };

    const carregarTermoNaoGarantia = async () => {
        const formData = new FormData();
        formData.append("function", "get_termo_nao_garantia_exito");
        formData.append("venda_id", vendaId);
        const res = await api.post(serverApi.urlPHP + '/venda.php', formData);

        if (res.data.termo_nao_garantia_exito_assinado) {
            return true;
        }

        if (res.data.termo_nao_garantia_exito_link) {
            setTermoNaoGarantiaLink(res.data.termo_nao_garantia_exito_link);
            setCurrentStep(STEP_NAO_GARANTIA);
            setNumPages(null);
            setIsLodingPdf(true);
            setErrorMessage(null);
            return false;
        }

        throw new Error("Termo de não garantia link não encontrado na resposta");
    };

    const carregarDados = async () => {
        try {
            setIsErro(false);
            setErrorMessage(null);
            setLoadingGrid(true);

            const contratoResolvido = await carregarContrato();
            if (!contratoResolvido) {
                return;
            }

            const sneResolvido = await carregarTermoSNE();
            if (!sneResolvido) {
                return;
            }

            const naoGarantiaResolvido = await carregarTermoNaoGarantia();
            if (!naoGarantiaResolvido) {
                return;
            }

            props.history.push(`/app/venda/forma-pagamento/${vendaId}`);
        } catch (e) {
            console.error("Erro ao carregar fluxo de termos:", e);
            console.error("Detalhes do erro:", e.response?.data || e.message);
            setErrorMessage(e.response?.data?.message || "Não foi possível consultar seu contrato no momento.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const validarContrato = () => {
        if (currentStep === STEP_CONTRATO) {
            setOpen(true);
        }
    };

    const aceitarContrato = async () => {
        try {
            setIsErro(false);
            setErrorMessage(null);
            setLoadingGrid(true);

            const formData = new FormData();
            formData.append("function", "assinar_contrato");
            formData.append("venda_id", vendaId);
            let ip = '';
            await fetch('https://api64.ipify.org?format=json')
            .then(response => response.json())
            .then(data => ip = data.ip);
            formData.append("ip_assinatura", ip);
            
            await api.post(serverApi.urlPHP + '/venda.php', formData);

            setOpen(false);

            const sneResolvido = await carregarTermoSNE();
            if (!sneResolvido) {
                return;
            }

            const naoGarantiaResolvido = await carregarTermoNaoGarantia();
            if (!naoGarantiaResolvido) {
                return;
            }

            props.history.push(`/app/venda/forma-pagamento/${vendaId}`);
        } catch (e) {
            console.error("Erro ao assinar contrato:", e);
            console.error("Detalhes do erro:", e.response?.data || e.message);
            setErrorMessage(e.response?.data?.message || "Não foi possível registrar o aceite do contrato.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const aceitarTermoSNE = async () => {
        try {
            setIsErro(false);
            setErrorMessage(null);
            setLoadingGrid(true);

            const formData = new FormData();
            formData.append("function", "assinar_termo_sne");
            formData.append("venda_id", vendaId);
            let ip = '';
            await fetch('https://api64.ipify.org?format=json')
            .then(response => response.json())
            .then(data => ip = data.ip);
            formData.append("ip_assinatura", ip);
            
            await api.post(serverApi.urlPHP + '/venda.php', formData);

            const naoGarantiaResolvido = await carregarTermoNaoGarantia();
            if (!naoGarantiaResolvido) {
                return;
            }

            props.history.push(`/app/venda/forma-pagamento/${vendaId}`);
        } catch (e) {
            console.error("Erro ao assinar termo SNE:", e);
            console.error("Detalhes do erro:", e.response?.data || e.message);
            setErrorMessage(e.response?.data?.message || "Não foi possível registrar o aceite do termo SNE.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const aceitarTermoNaoGarantia = async () => {
        try {
            setIsErro(false);
            setErrorMessage(null);
            setLoadingGrid(true);

            const formData = new FormData();
            formData.append("function", "assinar_termo_nao_garantia_exito");
            formData.append("venda_id", vendaId);
            let ip = '';
            await fetch('https://api64.ipify.org?format=json')
            .then(response => response.json())
            .then(data => ip = data.ip);
            formData.append("ip_assinatura", ip);
            await api.post(serverApi.urlPHP + '/venda.php', formData);

            props.history.push(`/app/venda/forma-pagamento/${vendaId}`);
        } catch (e) {
            console.error("Erro ao assinar termo de não garantia:", e);
            console.error("Detalhes do erro:", e.response?.data || e.message);
            setErrorMessage(e.response?.data?.message || "Não foi possível registrar o aceite do termo de não garantia de êxito.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const obterTituloEtapa = () => {
        switch (currentStep) {
            case STEP_CONTRATO:
                return "Aceite os termos abaixo para continuar:";
            case STEP_SNE:
                return "Leia e aceite o Termo de Ciência e Responsabilidade sobre o SNE:";
            case STEP_NAO_GARANTIA:
                return "Leia e aceite o Termo de Ciência sobre a Não Garantia de Êxito do Recurso:";
            default:
                return "Aceite os termos abaixo para continuar:";
        }
    };

    const obterTextoBotao = () => {
        switch (currentStep) {
            case STEP_CONTRATO:
                return "Li e concordo com os Termos de Contrato de Prestação de Serviços";
            case STEP_SNE:
                return "Li e concordo com o Termo SNE";
            case STEP_NAO_GARANTIA:
                return "Li e concordo com o Termo de Não Garantia de Êxito";
            default:
                return "Continuar";
        }
    };

    const obterAcaoBotao = () => {
        switch (currentStep) {
            case STEP_CONTRATO:
                return validarContrato;
            case STEP_SNE:
                return aceitarTermoSNE;
            case STEP_NAO_GARANTIA:
                return aceitarTermoNaoGarantia;
            default:
                return () => {};
        }
    };

    useEffect(() => {
        carregarDados();
    }, []);

    const documentoAtual = currentStep === STEP_CONTRATO
        ? contratoLink
        : currentStep === STEP_SNE
            ? termoSneLink
            : currentStep === STEP_NAO_GARANTIA
                ? termoNaoGarantiaLink
                : null;

    const tituloEtapa = obterTituloEtapa();
    const textoBotao = obterTextoBotao();
    const acaoBotao = obterAcaoBotao();

    const handleOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    return (
        <div>
            <LoadingGrid display={loadingGrid} />
            <ModalConfirmacaoAceiteContratoVenda open={open} aceitarContrato={aceitarContrato} />
            <div style={{ display: (!loadingGrid && !isErro ? '' : 'none') }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column", alignItems: "center", gap: "10px" }}>
                    <h3>{tituloEtapa}</h3>
                    <div 
                        style={{ minWidth: 600, minHeight: 400, border: "1px solid black" }}
                    >
                        {documentoAtual ? (
                            <Document
                                file={documentoAtual}
                                onLoadSuccess={({ numPages }) => {
                                    setNumPages(numPages);
                                    setIsLodingPdf(false);
                                }}
                                onLoadError={(error) => {
                                    console.error("Erro ao carregar PDF:", error);
                                    setIsLodingPdf(false);
                                    setErrorMessage("Erro ao carregar o PDF. Por favor, tente novamente.");
                                    setIsErro(true);
                                }}
                            >
                                {numPages && Array.from(new Array(numPages), (el, index) => (
                                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                                ))}
                            </Document>
                        ) : (
                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                Carregando documento...
                            </div>
                        )}
                    </div>

                    <div style={{ display: "flex" }}>
                        <Button
                            disabled={isLodingPdf || loadingGrid || !currentStep}
                            variant="contained"
                            onClick={acaoBotao}
                        >
                            {textoBotao}
                        </Button>
                    </div>
                </div>
            </div>
            <MySnackbarErro IsErro={isErro} Mensagem={errorMessage} />
        </div>
    );
}